__turbopack_context__.v({
  "productFooter": "product-footer-module-scss-module__o1of3a__productFooter",
  "productFooterLink": "product-footer-module-scss-module__o1of3a__productFooterLink",
  "productFooterTitle": "product-footer-module-scss-module__o1of3a__productFooterTitle",
});
